import { Controller } from "@hotwired/stimulus"
import Chartkick from 'chartkick'

export default class extends Controller{
  static targets = ["link"]
  
  connect() {
    const _this = this
    const _linkTarget = this.linkTarget
    setTimeout(function(){
      const chart = Chartkick.charts.progressmonitoringchart
      let chartConfig = chart.getChartObject().config
      chartConfig.options.layout = { padding: { left: 10, right: 10, top: 20, bottom: 20 } }
      chartConfig.options.interaction.mode = 'nearest'
      Object.entries(chartConfig.options.plugins.annotation.annotations).forEach(element => {
        
        const line = element[1]
        
        line.enter = ({element}, event) => {
          element.label.options.display = true;
          return true;
        }
        line.leave = ({element}, event) => {
          element.label.options.display = false;
          return true;
        }
      });
      chartConfig.options.plugins.tooltip = {
        position: 'top',
        callbacks: {
          label: (tooltipItem) => {
            const data = tooltipItem.chart.data;
            const datasetIndex = tooltipItem.datasetIndex;
            const index = tooltipItem.dataIndex;
            const datasetLabel = data.datasets[datasetIndex].label || "";
            
            const tooltipvalue = chart.dataSource[datasetIndex].data[index][3]
            return `${datasetLabel}: ${tooltipvalue}`;
          }
        }
      }
      chartConfig.options.maintainAspectRatio = false
      
      chart.getChartObject().update()
      chart.getChartObject().resize()
      
      chartConfig.options.onClick = (event, native, active) => { 
        if (native.length > 0) {
          const datasetIndex = native[0].datasetIndex;
          const index = native[0].index;
          const url = chart.dataSource[datasetIndex].data[index][2]
          _linkTarget.href = url
          _linkTarget.click()
        }
      }
    }, 1);
    

  } 
}